// Shared focus handling for both cart drawers; their open class remains the source of truth.
(function() {
  'use strict';
  if (window.VPCartAccessibility) return;

  var overlay = document.getElementById('cartOverlay');
  if (!overlay) return;
  var drawer = overlay.querySelector('.cart-drawer');
  var active = false;
  var returnFocus = null;
  var lastFocus = null;
  var lastKey = null;
  var lastIndex = 0;
  var blocked = [];
  var focusSelector = 'a[href], button, input, select, textarea, [tabindex], [contenteditable="true"]';

  function available(el) {
    return el && el.isConnected && !el.disabled &&
      !el.closest('[inert], [hidden], [aria-hidden="true"]') &&
      el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  }

  function controls() {
    return Array.from(drawer.querySelectorAll(focusSelector)).filter(function(el) {
      return el.tabIndex >= 0 && available(el);
    });
  }

  function focus(el) {
    if (el) el.focus({ preventScroll: true });
  }

  function remember(el) {
    lastFocus = el;
    lastKey = el.getAttribute('data-cart-focus');
    lastIndex = Math.max(0, controls().indexOf(el));
  }

  function repairFocus() {
    if (!active) return;
    if (drawer.contains(document.activeElement) && available(document.activeElement)) return;
    var list = controls();
    var target = list.find(function(el) {
      return lastKey && el.getAttribute('data-cart-focus') === lastKey;
    });
    focus(target || (available(lastFocus) ? lastFocus : list[Math.min(lastIndex, list.length - 1)]) || drawer);
  }

  function blockBackground() {
    var branch = overlay;
    while (branch.parentElement) {
      Array.from(branch.parentElement.children).forEach(function(el) {
        if (el === branch || /^(SCRIPT|STYLE|LINK)$/.test(el.tagName) || el.id === 'cartNotif' || el.hasAttribute('inert')) return;
        el.setAttribute('inert', '');
        blocked.push(el);
      });
      branch = branch.parentElement;
      if (branch === document.body) break;
    }
  }

  function restoreFocus() {
    var target = available(returnFocus) && !overlay.contains(returnFocus) && returnFocus !== document.body
      ? returnFocus : document.querySelector('.cart-pill-btn');
    if (!available(target)) target = document.querySelector('main') || document.body;
    var tabIndex = target.getAttribute('tabindex');
    if (target.tabIndex < 0) target.setAttribute('tabindex', '-1');
    focus(target);
    if (tabIndex === null) target.removeAttribute('tabindex');
    else target.setAttribute('tabindex', tabIndex);
  }

  function sync() {
    var open = overlay.classList.contains('open');
    if (open && !active) {
      returnFocus = document.activeElement;
      lastFocus = null;
      lastKey = null;
      lastIndex = 0;
      overlay.removeAttribute('inert');
      overlay.setAttribute('aria-hidden', 'false');
      active = true;
      blockBackground();
      pageObserver.observe(document.body, { childList: true, subtree: true });
      focus(drawer.querySelector('.cart-drawer-close') || drawer);
    } else if (!open && active) {
      active = false;
      pageObserver.disconnect();
      blocked.forEach(function(el) { el.removeAttribute('inert'); });
      blocked = [];
      restoreFocus();
      overlay.setAttribute('inert', '');
      overlay.setAttribute('aria-hidden', 'true');
      returnFocus = null;
      lastFocus = null;
    } else if (open) {
      repairFocus();
    }
  }

  var pageObserver = new MutationObserver(function() {
    if (!active) return;
    blockBackground();
    repairFocus();
  });
  var cartObserver = new MutationObserver(sync);
  cartObserver.observe(overlay, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'disabled']
  });

  document.addEventListener('focusin', function(e) {
    if (!active) return;
    if (drawer.contains(e.target)) remember(e.target);
    else repairFocus();
  }, true);

  document.addEventListener('keydown', function(e) {
    if (!active || !overlay.classList.contains('open')) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopImmediatePropagation();
      closeCartDrawer(null);
      sync();
      return;
    }
    if (e.key !== 'Tab') return;
    var list = controls();
    var index = list.indexOf(document.activeElement);
    if (!list.length) {
      e.preventDefault();
      focus(drawer);
    } else if (index < 0 || (e.shiftKey && index === 0) || (!e.shiftKey && index === list.length - 1)) {
      e.preventDefault();
      focus(e.shiftKey ? list[list.length - 1] : list[0]);
    }
  }, true);

  window.VPCartAccessibility = { sync: sync };
  sync();
})();
